const BannerData = {
    videoUrl: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2FEV9_Desktop.mp4?alt=media&token=696e705e-9d10-4580-ab50-d35f03623d43",
    title: "All-New Kia EV6",
    subtitle: "The Electric Superstar",
    price: "",
    features: [
        {
            imgSrc:
                "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2FPaddle-Shifter.webp?alt=media&token=5de55469-30f9-4dc2-baed-a5f3731284ef",
            text: "Packed with more than 25 ADAS 2.0 features.",
        },
        {
            imgSrc:
                "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Ficon-speaker.webp?alt=media&token=c0220524-125b-4b14-ade0-ccadcd0e9b61",
            text: "Exceptional experience to elevate the senses.",
        },
        {
            imgSrc:
                "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Ficon-touchscreen.webp?alt=media&token=e3748348-053e-45a0-ace1-cd13ca4c5594",
            text: "Fully charged, it offers 3.6 kW of power to run multiple devices",
        },
    ],
};

const caroData = [
    {
        cover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2FSec1-d.webp?alt=media&token=c24e25cd-f0e8-4cb3-92b1-278e0e24ae8e",
        type: "imgbanner",
        title: " ",
        subtitle: " ",
    },
    {
        cover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2FSec2-d.webp?alt=media&token=8dcedd3c-a303-4244-aa6f-aa7243165ac9",
        type: "imgbanner",
        title: " ",
        subtitle: " ",
    },
    {
        cover: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2FSec3-d.webp?alt=media&token=e7081b44-af85-442b-89eb-c854fa258bb3",
        type: "imgbanner",
        title: " ",
        subtitle: " ",
    },
]

const CircleData = [
    {
        title: "Snow White Pearl",
        color: "#dcd5d5ff",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fsnow%20white%20pearl.webp?alt=media&token=65aa4ffd-f728-4543-a6d9-86e9bc3ae7f8",
    },
     {
        title: "Wolf Grey",
        color: "#8f8f8f",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fwolf%20gray%20ev6.webp?alt=media&token=2516ad77-6ca9-4a03-b935-a07107fc7e0d",
    }, {
        title: "Aurora Black Pearl",
        color: "#000000",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Faurora%20black%20ev6.webp?alt=media&token=fd1f4b12-60b5-4f43-959c-00498f90f1c6",
    }, {
        title: " Ocean Blue",
        color: "rgb(155, 18, 18)",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Frunway%20red%20ev6.webp?alt=media&token=748ad141-6ca5-4856-b9ef-2e618d8a5c0c",
    },
];

const TrimData = [
    {
        title: "GT-Line AWD",
        cost: "65,96,638",
        feature1: `Panaramic curved display (12.3" touchscreen + 12.3" cluster)`,
        feature2: "ADAS 2.0 with 27 features",
        feature3: "Digital key 2.0",
        feature4: "Ultra-fast charging (10%--> 80% in 18 mins (350 kW charger)",
        feature5: "650+ Km range",
        feature6: "V2L (Vehicle to load) and V2V (Vehicle to Vehicle)",
        feature7: "Augmented reality HUD",
    },
]

const DetailInfo = [
    {
        bgColor: "#FFF",
        color: "#000",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fcard1.webp?alt=media&token=e7468593-e0fd-44ba-bc72-fb611e13997a",
        title: "Book Your EV6 Today",
        desc: "Its time to own the most inspiring Kia ever",
        link: "",
    },
    {
        bgColor: "#05141f",
        color: "#FFF",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fcard2.webp?alt=media&token=fc1fabb9-93a5-410d-9e21-f0f4b6e4ea66",
        title: "Download Brochure",
        desc: "Learn more about its wild possibilities",
        link: "https://www.kia.com/content/dam/kia2/in/en/images/buy/download-brochure/ev6/EV6_Desktop_2025.pdf",
    },
    {
        bgColor: "#FFF",
        color: "#000",
        imgSrc:
            "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/EV6%2Fcard3.webp?alt=media&token=30ef3940-794e-4474-a025-c7059507a071",
        title: "Call us for more information",
        desc: "We'll be happy to answer all your queries. 0000000000",
        link: "tel:+919237386213",
    },
];

const caro3in1Data = [
    {
        image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fse1.webp?alt=media&token=ea356de5-9f4d-4f3d-ada9-89658fc9111f",
        mobileCover: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV6%2Fse1.avif?alt=media&token=43814ef1-ccc5-428b-965b-9c086f14301e",
        title: 'Sustainable Material ',
        desc: 'Embracing sustainability, it features black suede seats with vegan leatherette bolsters and a cabin crafted with recycled materials.​',
    },
    {
        image: 'https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fse2.webp?alt=media&token=6be4cba9-e87d-4162-b008-1ce9e74372b5',
        mobileCover: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV6%2Fse2.avif?alt=media&token=3140c35c-4789-4cb7-bf07-e14b2abf6b91",
        title: 'Remote Folding 60:40 Split Rear Seats',
        desc: 'Pull the conveniently located remote release lever on the wall of the cargo space to fold the rear seatback down, creating 1,300 l** of storage capacity',
    },
    {
        image: 'https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fse3.webp?alt=media&token=503da44f-1297-4cc0-9993-b2613195e91a',
        mobileCover: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV6%2Fcard3.jpg?alt=media&token=e392128f-a5d6-4e42-ad3c-d10c78448da4",
        title: 'Wide Electric Sunroof',
        desc: ' With a wide sunroof, our inspiring EV car - The Kia EV6, seem to expand its roomy dimensions. ',
    },
    {
        image: 'https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fse4.webp?alt=media&token=4180c8b5-326a-47f6-ab72-0d4c9f7e6ea0',
        mobileCover: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV6%2FSe2-Ba.avif?alt=media&token=60f18666-cf65-45b3-9b58-6d75ec7011ce",
        title: 'Starmap LED Rear Combination Lamp with Sequential Indicators​',
        desc: 'The dynamic curved shape full LED tail light lends sleek and futuristic look to the rear of EV6',
    },
    {
        image: 'https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fse5.webp?alt=media&token=094769c5-e498-4a51-8b11-f021551b79df',
        mobileCover: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV6%2Fcard5.jpg?alt=media&token=d7aba631-47ae-48a2-b26e-c4fc11a46ac9",
        title: 'Body-Colored Streamline Door Handles​',
        desc: ' Streamlined door handles designed to stay hidden, enhancing the sleek profile and unlocking with ease.​',
    },
    {
        image: 'https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fse6.webp?alt=media&token=89fe913a-4e78-4b65-a8d4-f3c262e469e7',
        mobileCover: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV6%2FSe2-A.avif?alt=media&token=336ec446-f2b2-49b0-ac78-1f2d87885483",
        title: 'R19 – 48.74 cm (19”) Aerodynamic Gloss Finish Alloy Wheels​​',
        desc: 'Striking design meets electrifying performance – crafted for an aerodynamic drive.',
    },
    {
        image: 'https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fse7.webp?alt=media&token=7a42fa01-4b70-44c8-96ed-ef821356cbe3',
        mobileCover: "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/EV6%2FSe3.avif?alt=media&token=3202cf0e-1265-436c-9a2f-8355c0506064",
        title: 'Dual LED Headlamps with Adaptive Driving Beam',
        desc: 'The distinctive headlamps not only have a progressive design language but also the intelligence to automatically adjust to avoid dazzling oncoming vehicles​',
    },
];

const gridData = [
    {
        type: 'img',
        item: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2F600X800%20(1).webp?alt=media&token=7d008b9d-58ff-4bfb-9743-d3bfc581f36f",
    },
    {
        type: 'text',
        item1: "Space Innovation",
        item2: "Driver and Passenger Relaxation Seats",
        item3: "Front seats recline at the press of a button to a zero-gravity position to give maximum relaxation to the occupant",
    },
    {
        type: 'img',
        item: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2F600x800(2).webp?alt=media&token=c3332dab-306a-4209-b22b-2e8f87111cf6",
    },
    {
        type: 'text',
        item1: "Dual 12.3” (31.24 cm) Panoramic Curved Display​",
        item2: "Driver and Passenger Relaxation Seats",
        item3: "",
    },
    {
        type: 'img',
        item: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2F600x800(3).webp?alt=media&token=62878e56-e6c6-4fd1-a765-4d9d6ecc1788",
    },
    {
        type: 'text',
        item1: "Augmented Reality Head-Up Display",
        item2: "Key information such as speed, and lane safety indication, is projected in an intuitive manner on the windscreen",
        item3: "",
    },
];

const com3struct = [
    {
        type: "text",
        backgroundColor: "#1d1d1d",
        color: "white",
        heading: "Electrifying performance",
        description: [
            "The Electric is in the engineering but the EV6 stands for so much more.",
            "It emotes the excitement that comes from its performance.",
            "The powerful all-electric motor’s 605 Nm torque gives instantaneous acceleration,",
            "while a low centre of gravity offers sporty handling, making the EV6 an absolute pleasure to drive.",
        ],
    },
    {
        type: "image",
        url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fkiaev6%20full1.webp?alt=media&token=6abba7ec-d481-4c02-b7ce-ffdb67f8f0cc",
        height: {
            md: "70vh",
            sm: "60vh",
            xs: "40vh",
        },
    },
    {
        type: "cards",
        items: [
            {
                title: " All Wheel Drive",
                description: "The dual motor AWD system delivers superior acceleration and all-weather grip. Switches between AWD and RWD within 0.4 seconds depending on the requirement",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fallwheeldrive.webp?alt=media&token=16d2c59b-a69c-4b1a-9bbc-92733a5776b8",
            },
            {
                title: "Drive Modes",
                description: "Choose from Normal, Sport or Eco drive modes. Each mode provides a significant performance change to suit the requirement along with a unique driver interface",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fev6card2.webp?alt=media&token=94392193-923a-44ea-8c3b-23f39ac9f454",
            },
            {
                title: "Aerodynamics",
                description: " The super sleek design with active air flaps and aerodynamic enhancements make EV6 move quickly and efficiently",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fev6car.webp?alt=media&token=31fb764b-216e-43d9-842b-3f2eeb814e91",
            },
        ],
    },





    {
        type: "image",
        url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fultrafast_charging.webp?alt=media&token=92cf0264-2c6d-48a3-83c7-5ba732b0f999",
        height: {
            md: "120vh",
            sm: "60vh",
            xs: "40vh",
        },
    },


    {
        type: "cards",
        items: [
            {
                title: " Vehicle-to-load (V2L)",
                description: "Fully charged, EV6 offers 3.6 kW of power to run multiple devices inside and outside by attaching Vehicle-to-Load connector",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fvehicle1.webp?alt=media&token=067231c1-b651-421b-820d-884249a474cd",
            },
            {
                title: "650+ Km Driving Range^",
                description: " With a 84 kWh battery pack, the Kia EV6 lets you explore more of what the world has to offer",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fvehicle2.webp?alt=media&token=84164a62-47dc-4c0e-bd8f-798346c4d279",
            },
            {
                title: "Electric Global Modular Platform (E-GMP) ",
                description: "  The New E-GMP platform introduces a flat floor, facilitating comfort and utility along with greater power, driving range and control",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fvehicle3.webp?alt=media&token=7ac522fc-c5d5-42f8-ac56-eb05cbd2e186",
            },
        ],
    },








    {
        type: "text",
        backgroundColor: "#1d1d1d",
        color: "white",
        heading: "Connected to inspire",
        description: [
            "Stay seamlessly connected with Kia Connect 2.0, offering over 100 innovative features to keep you in control.",
            "From communication to entertainment,",
            "experience a world of convenience at your fingertips.​",

        ],
    },
    {
        type: "image",
        url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fev6%20full%202.webp?alt=media&token=2b7acdd0-be19-4f3a-a3d8-075923478fdf",
        height: {
            md: "70vh",
            sm: "60vh",
            xs: "40vh",
        },
    },





    {
        type: "cards",
        items: [
            {
                title: " EV Remote Climate Control",
                description: " Climate stays delightful without taking anything away from the environment. Just switch on the climate control using the Kia Connect application. You can even schedule Remote Cooling based on your convenience",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fclimet1.webp?alt=media&token=74dfcc0b-c6e2-4498-84ef-f35ec4bbf287",
            },
            {
                title: "EV Remote Charging Control",
                description: "  Once the connector is plugged in, you can switch on/off the charging as per your need. Schedule the charge without any discomfort ",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fclimet2.webp?alt=media&token=beb914c7-d0ae-46c9-90d7-9f8ee0542ae3",
            },
            {
                title: "Surround View Monitoring ",
                description: "  Stay in control of the world outside. View a video around your EV6 according to the camera angles and monitor your surroundings",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fclimet3.webp?alt=media&token=b3dbb04b-2b3b-42e2-acd1-2e03c9b721f3",
            },
        ],
    },




    {
        type: "text",
        backgroundColor: "#1d1d1d",
        color: "white",
        heading: "Step into the future",
        description: [
            "Unlike any other electric car,stepping into the Kia EV6, is like stepping into a future studded with infinite luxuries.",
            "A minimalistic yet hi-tech driver-centric cockpit offers the most immersive experience through design,",
            "intuitive technologies, and sustainable elements, to make your journeys even more mesmerizing​",

        ],
    },
    {
        type: "image",
        url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fev6%20full%203.webp?alt=media&token=6b2645ac-f0b1-4504-9891-728048f47e45",
        height: {
            md: "70vh",
            sm: "60vh",
            xs: "40vh",
        },
    },


    {
        type: "cards",
        items: [
            {
                title: " Dual 12.3” (31.24 cm) Panoramic Curved Display​",
                description: "The interface lays out all essential pieces of information for clarity about range, forecast battery charge time, Vehicle-to-Load status and much more",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fdual1.webp?alt=media&token=58628f5d-67c9-4af7-9987-560678b1b761",
            },
            {
                title: "The Meridian Premium Sound System with 14 Speakers",
                description: " The Meridian Premium Sound System is the ultimate luxury for ears. 14 speakers create an exceptional experience to elevate the senses",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fdual2.webp?alt=media&token=ae2f0386-7c44-4dfe-9bc3-8c6072b10329",
            },

        ],
    },




    {
        type: "text",
        backgroundColor: "#1d1d1d",
        color: "white",
        heading: "Less to search, more to discover",
        description: [
            "Let our technology handle the details, so you can stay connected to the journey. By priortising information, The Kia EV6 - our",
            "fully electric car, lets you take in more of the world outside and spend less time scanning screens and dials.",
            "This is what makes EV6 the most convenient electric vehicle on the streets.",

        ],
    },
    {
        type: "image",
        url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fev6%20full%204.webp?alt=media&token=2345ee0c-c220-46e7-bb5a-4113d7f96c75",
        height: {
            md: "100vh",
            sm: "60vh",
            xs: "40vh",
        },
    },

    {
        type: "cards",
        items: [
            {
                title: "Smart Power Tailgate​",
                description: "The power tailgate can be set to open automatically to the desired height",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fsmartp1.webp?alt=media&token=69a2b576-33b6-474b-a552-836d137bfbf5",
            },
            {
                title: "Shift By Wire",
                description: " Change gear position simply by turning the dial of Shift by Wire left or right",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fsmartp2.webp?alt=media&token=ccbf95cd-c318-4696-ba85-955d27085678",
            },

        ],
    },

    {
        type: "text",
        backgroundColor: "#1d1d1d",
        color: "white",
        heading: "Safety from every possible angle",
        description: [
            "Kia's luxury electric car - TThe Kia EV6 is packed with more than 25 Advanced Driver Assistance System 2.0 (ADAS 2.0) features like",
            "Forward Collision-Avoidance Assist (FCA), Lane Keep Assist (LKA), 8 airbags, and more",

        ],
    },
    {
        type: "image",
        url: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fev6%20safty%20full.webp?alt=media&token=4c7ff699-95a3-4406-82db-193cfad9e767",
        height: {
            md: "100vh",
            sm: "60vh",
            xs: "40vh",
        },
    },




    {
        type: "cards",
        items: [
            {
                title: "Rear-cross Traffic Avoidance Assist (RCTA)​",
                description: "This warns in case a vehicle or pedestrian is coming while reversing. It automatically assists with emergency breaking if collision is sensed",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fcross1.webp?alt=media&token=a52dca12-38b2-4141-b5c0-6c949b0cf50f",
            },
            {
                title: "Safe Exit Assist (SEA)",
                description: "Child lock is automatically activated along with a warning sound when an occupant attempts to open their door while a vehicle is approaching from the back",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fcross2.webp?alt=media&token=3e71acc9-2655-4b76-8086-fff2cc27739d",
            },
            {
                title: "Blind-Spot Collision-Avoidance Assist (BCA)",
                description: "When you signal a lane change, you are warned if a risk of collision is detected with a vehicle beside you or approaching from the rear ",
                image: "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/ev66%2Fcross3.webp?alt=media&token=8c5ea1ff-c215-483c-83b6-83867929f950",
            },


        ],
    },

];
const Caro3Heading = {
    heading: "Meet our Global Superstar"
}


export { BannerData, caroData, CircleData, TrimData, DetailInfo, caro3in1Data, gridData, com3struct, Caro3Heading };